export default {
  install: function (Vue) {
    const get = (key, defaultValue) => {
      if (has(key) === false) {
        set(key, defaultValue)
      }

      return JSON.parse(sessionStorage.getItem(key))
    }

    const set = (key, value) => {
      return sessionStorage.setItem(key, JSON.stringify(value))
    }

    const has = (key) => {
      return Boolean(sessionStorage.getItem(key))
    }

    Object.defineProperty(Vue.prototype, '$sessionStorage', {
      get () {
        return { get, set, has }
      }
    })
  }
}
